/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ActivityStateResource = {
    PendingActions: 'PENDING_ACTIONS',
    NoActionYet: 'NO_ACTION_YET',
    NoMoreAction: 'NO_MORE_ACTION',
    NoMoreActionCompletionRequested: 'NO_MORE_ACTION_COMPLETION_REQUESTED',
    NoMoreActionProjectOver: 'NO_MORE_ACTION_PROJECT_OVER'
} as const;
export type ActivityStateResource = typeof ActivityStateResource[keyof typeof ActivityStateResource];


export function instanceOfActivityStateResource(value: any): boolean {
    for (const key in ActivityStateResource) {
        if (Object.prototype.hasOwnProperty.call(ActivityStateResource, key)) {
            // @ts-ignore
            if (ActivityStateResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActivityStateResourceFromJSON(json: any): ActivityStateResource {
    return ActivityStateResourceFromJSONTyped(json, false);
}

export function ActivityStateResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivityStateResource {
    return json as ActivityStateResource;
}

export function ActivityStateResourceToJSON(value?: ActivityStateResource | null): any {
    return value as any;
}

